export enum CacheStrategy {
  CacheFirst = 'cache-first',

  NetworkFirst = 'network-first',

  StaleWhileRevalidate = 'stale-while-revalidate',

  NetworkOnly = 'network-only',
}

export interface PersistedEntry<T = unknown> {
  key: string

  endpoint: string

  version: number

  createdAt: number

  expiresAt: number

  data: T
}

export interface PersistRule {
  ttl: number

  strategy?: CacheStrategy
}

export type PersistRules = Record<string, PersistRule>

export interface CacheArgs {
  version: number
  storeName: string
  dbName: string
}
